import { useTranslation } from 'react-i18next'

export const usePaymentMethod = () => {
	const { t } = useTranslation()

	return [
		{
			value: 'external',
			label: t('External')
		},
		{
			value: 'verifone',
			label: t('Verifone')
		},
		{
			value: 'korta',
			label: t('Korta')
		},
		{
			value: 'rapyd',
			label: t('Rapyd')
		},
		{
			value: 'netgiro',
			label: t('Netgiro')
		}
	]
}
